import { connect } from 'react-redux';
import Navigator from './navigator';

const mapStateToProps = state => ({
  routeName: state.navigator.route,
});

export default connect(mapStateToProps)(Navigator);
